// extracted by mini-css-extract-plugin
export var card = "_t0-0";
export var details = "_t0-1";